const doc = [({"da":({"js":({"merfoto":({"photo_session_group_contact_tokens":({"create_from_token_form":({"enter_your_token_here":"Skriv din kode her..."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;